import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { apiClient } from '../../../helpers/api_helper';
import { Spinner } from "reactstrap";

const Basic = () => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    fetchChartData();
  }, []);

  const fetchChartData = async () => {
    try {
      const response = await apiClient.get('/analytics/actividades-por-mes/');
      setChartData(response.data ? response.data : response);
    } catch (error) {
      console.error('Error fetching chart data:', error);
    }
  };

  const series = [{
      name: "Actividades",
      data: chartData,
    },
  ];
  const options = {
    chart: {
      zoom: {
        enabled: !1,
      },
      toolbar: {
        show: !1,
      },
    },

    markers: {
      size: 4,
    },
    dataLabels: {
      enabled: true,
      offsetY: -10,
      style: {
        colors: ["#ffffff11"],
      },
    },
    stroke: {
      curve: "straight",
    },
    colors: ["#038edc"],

    xaxis: {
      categories: ["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"],
    },
  };

  return (
    chartData ? (
    <React.Fragment>
      <ReactApexChart
        options={options}
        series={series}
        type="line"
        height={350}
        className="apex-charts"
      />
    </React.Fragment>
    ):(<Spinner color="primary" />)
  );
};

export default Basic;
